import { Plus } from "lucide-react";
import { ModalTrigger } from "./ModalTrigger";
import { Portfolio } from "global-types";

interface NewPropertyTriggerProps {
  portfolios: Portfolio[];
}

export const NewPropertyTrigger = ({ portfolios }: NewPropertyTriggerProps) => {
  return (
    <ModalTrigger
      modalPath="/modals/property/create"
      modalState={{ portfolios }}
      className="cursor-pointer bg-lime text-foreground hover:text-background w-40 h-8 flex mx-auto"
    >
      <Plus className="w-4 h-4" />
      New Property
    </ModalTrigger>
  );
};
